const formTemplate = {
  'areaCode': '',
  'areaName': '',
  'containArea': '',
  'guardian': {
		'address': '',
    'accordType': '',
    'areaCode': '',
    'areaName': '',
    'certificateType': '',
    'cityCode': '',
    'cityName': '',
    'companyCode': '',
    'companyName': '',
    'countryName': '',
    'education': '',
    'guardianType': '',
    'houseNumber': '',
    'idCard': '',
    'jobType': '',
    'mobile': '',
    'name': '',
    'nationName': '',
    'proofType': '',
    'provinceCode': '',
    'provinceName':'',
    'relationType': '',
    'relationship': '',
    'residenceType': '',
    'sex': '',
    'socialSecurityProve': '',
    'streetId': '',
    'villageCode': '',
    'villageName': '',
  },
  'hasStudentStatus': '',
  'oldSchoolName': '',
  'orderGradeName': '',
  'orderSchoolId': '',
  'orderSchoolName': '',
  'orderStreetCode': '',
  'orderStreetName': '',
  'signupNoticeId': '',
  'signupQuotaId': '',
  'student': {
    'address': '',
    'applyType': '',
    'areaCode': '',
    'areaName': '',
    'birthday': '',
    'cityCode': '',
    'cityName': '',
    'homePage': '',
    'idCard': '',
    'name': '',
    'nationName': '',
    'nativeAreaCode': '',
    'nativeAreaName': '',
    'nativeCityCode': '',
    'nativeCityName': '',
    'nativeProvinceCode': '',
    'nativeProvinceName': '',
    'nativeStreetCode': '',
    'nativeStreetName': '',
    'nativeVillageCode': '',
    'nativeVillageName': '',
    'photo': '',
    'provinceCode': '',
    'provinceName': '',
    'sex': '',
    'studentPage': '',
  },
  'studentSignupId':'',
  'studentType': '',
};

export default {
  data() {
    return {
      form: {}
    };
  },
  created() {
    window.form2 = this.form;
  },
  methods: {
    updateFormData() {
      console.log('[-> PageForm.js] updateFormData');
      // 更新sessionStorage中存的数据到当前form中
      try {
        let data = sessionStorage.getItem('signupMobileForm');
				if (data) data = JSON.parse(data);
				if (!data) {
					this.$router.push({
						path: '/mobile/index'
					});
				}
        console.log('[-> PageForm.js] 从sessionStorage中获取到了form信息', data);
        // 补全字段
        if (!data.student) {
          data.student = {};
        }
        if (!data.guardian) {
          data.guardian = {};
        }
        // 转换字段
        if (data['studentApplyType']) {
          data.student['applyType'] = data['studentApplyType'];
          delete data['studentApplyType'];
        }
        if (data['studentName']) {
          data.student['name'] = data['studentName'];
          delete data['studentName'];
        }
        if (data['idCard']) {
          data.student['idCard'] = data['idCard'];
          delete data['idCard'];
        }
        if (data['guardianMobile']) {
          data.guardian['mobile'] = data['guardianMobile'];
          delete data['guardianMobile'];
        }
        // 转换格式
        if (data.student['idCard']) {
          data.student['birthday'] = this.makeBirthdayByIdCard(data.student['idCard']);
        }
        // 更新
        this.form = data;
      } catch (e) {
        console.error('[-> PageForm.js] updateFormData error', e);
      }
    },
    saveFormData(obj) {
      console.log('[-> PageForm.js] saveFormData', obj);
      // 保存当前数据到sessionStorage中
      try {
        if (typeof obj === 'object') sessionStorage.setItem('signupMobileForm', JSON.stringify(obj));
      } catch (e) {
        console.error('[-> PageForm.js] saveFormData error', e);
      }
    },
    makeBirthdayByIdCard(idCard) {
      return idCard.substring(6, 10) + '-' + idCard.substring(10, 12) + '-' + idCard.substring(12, 14);
    },

    formatFormData(obj) {
      // 格式化从后端获取到的数据，保持跟提交的数据格式完全一致
      for (let key in obj) {
        if (typeof obj[key] === 'object' && formTemplate[key]) {
          for (let sub_key in obj[key]) {
            if (formTemplate[key] && !formTemplate[key][sub_key]) delete obj[key][sub_key];
          }
        } else {
          if (!formTemplate[key]) delete obj[key];
        }
      }
      return obj;
    }
  }
}
